import { useState } from "react";

const features = [
  { icon: "📶", text: "Offline listening mode" },
  { icon: "🎵", text: "High quality audio streaming" },
  { icon: "✨", text: "Personalized recommendations" },
  { icon: "🔔", text: "Live event notifications" },
];

const songList = [
  { title: "शिव तांडव स्तोत्र", duration: "5:24", lang: "Sanskrit" },
  { title: "गणपती आरती", duration: "3:45", lang: "Marathi" },
  { title: "हनुमान चालीसा", duration: "7:12", lang: "Hindi" },
  { title: "ओम नमः शिवाय", duration: "4:30", lang: "Sanskrit" },
  { title: "सुप्रभात स्तोत्र", duration: "6:08", lang: "Marathi" },
];

const AndroidIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M17.523 15.341a1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1m-9.046 0a1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1M5.18 8.907l-1.593-2.76a.33.33 0 01.12-.45.33.33 0 01.45.12l1.614 2.794A9.577 9.577 0 0112 7.5c1.44 0 2.8.316 4.03.886l1.614-2.794a.33.33 0 01.45-.12.33.33 0 01.12.45l-1.593 2.76A9.463 9.463 0 0121 16.5H3a9.463 9.463 0 012.18-7.593z" />
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
    <path d="M8 5v14l11-7z" />
  </svg>
);

export default function AppDownloadSection() {
  const [hoveredBtn, setHoveredBtn] = useState(null);
  const [activeTrack, setActiveTrack] = useState(1);

  return (
    <div className="app-section">
      {/* Background blobs */}
      <div className="blob-top-right" />
      <div className="blob-bottom-left" />

      <div className="inner">
        {/* ── LEFT COLUMN ── */}
        <div className="left">
          <span className="eyebrow">DOWNLOAD NOW</span>

          <h1 className="heading">ॲप डाउनलोड करा</h1>

          <p className="subheading">Get Our Mobile App</p>

          <p className="body-text">
            आता आपल्या मोबाइलवर संगीत विद्यालय शिवाजी ॲप डाउनलोड करा आणि
            कोठेही, कधीही आध्यात्मिक संगीत ऐका। हजारो भजन, आरती आणि भक्तिगीत
            आपल्या अंगठी टोकात।
          </p>

          <ul className="feature-list">
            {features.map((f, i) => (
              <li key={i} className="feature-item">
                <span className="bullet" />
                <span className="feature-text">{f.text}</span>
              </li>
            ))}
          </ul>

          <div className="btn-row">
            <button
              className={`btn-android ${hoveredBtn === "android" ? "btn--hovered" : ""}`}
              onMouseEnter={() => setHoveredBtn("android")}
              onMouseLeave={() => setHoveredBtn(null)}
            >
              <AndroidIcon />
              Android App
            </button>

            <button
              className={`btn-ios ${hoveredBtn === "ios" ? "btn--hovered" : ""}`}
              onMouseEnter={() => setHoveredBtn("ios")}
              onMouseLeave={() => setHoveredBtn(null)}
            >
              <AppleIcon />
              iOS App
            </button>
          </div>
        </div>

        {/* ── RIGHT COLUMN — Mock Phone UI ── */}
        <div className="right">
          {/* Downloads badge */}
          <div className="downloads-badge">
            <DownloadIcon />
            <span className="downloads-text">5K+ Downloads</span>
          </div>

          {/* Phone mockup */}
          <div className="phone">
            <div className="notch" />

            <div className="app-header">
              <div className="app-icon-wrap">
                <span className="app-icon-emoji">📱</span>
              </div>
              <div>
                <div className="app-name">संगीत विद्यालय</div>
                <div className="app-tagline">Spiritual Music App</div>
              </div>
            </div>

            <div className="song-list">
              {songList.map((song, i) => (
                <div
                  key={i}
                  className={`song-row ${activeTrack === i ? "song-row--active" : ""}`}
                  onClick={() => setActiveTrack(i)}
                >
                  <div className={`song-thumb ${activeTrack === i ? "song-thumb--active" : ""}`}>
                    {activeTrack === i
                      ? <PlayIcon />
                      : <span style={{ fontSize: "10px" }}>♪</span>}
                  </div>
                  <div className="song-info">
                    <div className={`song-title ${activeTrack === i ? "song-title--active" : ""}`}>
                      {song.title}
                    </div>
                    <div className="song-meta">{song.lang} · {song.duration}</div>
                  </div>
                  <div className="song-duration">{song.duration}</div>
                </div>
              ))}
            </div>

            <div className="mini-player">
              <div className="mini-player-left">
                <div className="mini-thumb">▶</div>
                <div>
                  <div className="mini-title">{songList[activeTrack].title}</div>
                  <div className="mini-sub">Now Playing</div>
                </div>
              </div>
              <div className="progress-bar">
                <div className="progress-fill" />
              </div>
            </div>

            <div className="home-bar" />
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Noto+Sans+Devanagari:wght@400;500;700;800&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
        }
        @keyframes blobPulse {
          0%, 100% { transform: scale(1); opacity: 0.6; }
          50% { transform: scale(1.08); opacity: 0.8; }
        }
        @keyframes progressAnim {
          from { width: 0%; }
          to { width: 62%; }
        }

        /* ── Section ── */
        .app-section {
          background: linear-gradient(135deg, #b71c1c 0%, #8b1a1a 40%, #5c1010 100%);
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          padding: 60px 48px;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        /* ── Blobs ── */
        .blob-top-right {
          position: absolute;
          top: -80px; right: -80px;
          width: 420px; height: 420px;
          border-radius: 50%;
          background: radial-gradient(circle, #d4522a88 0%, transparent 70%);
          animation: blobPulse 8s ease-in-out infinite;
          pointer-events: none;
        }
        .blob-bottom-left {
          position: absolute;
          bottom: -100px; left: -60px;
          width: 350px; height: 350px;
          border-radius: 50%;
          background: radial-gradient(circle, #4a0e0e66 0%, transparent 70%);
          animation: blobPulse 10s ease-in-out infinite reverse;
          pointer-events: none;
        }

        /* ── Inner grid ── */
        .inner {
          position: relative;
          z-index: 1;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
          max-width: 1200px;
          width: 100%;
        }

        /* ── LEFT ── */
        .left {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .eyebrow {
          font-family: 'Cinzel', serif;
          font-size: 12px;
          letter-spacing: 5px;
          color: #d4a857;
          font-weight: 600;
        }
        .heading {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: clamp(36px, 5vw, 64px);
          font-weight: 800;
          color: #ffffff;
          line-height: 1.15;
          text-shadow: 0 3px 20px rgba(0,0,0,0.3);
        }
        .subheading {
          font-family: 'Cinzel', serif;
          font-size: 18px;
          font-weight: 700;
          color: #d4a857;
          letter-spacing: 0.5px;
        }
        .body-text {
          font-size: 15px;
          color: rgba(255,255,255,0.75);
          line-height: 1.8;
          max-width: 480px;
        }
        .feature-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 4px 0;
        }
        .feature-item {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .bullet {
          width: 9px; height: 9px;
          border-radius: 50%;
          background: #d4a857;
          flex-shrink: 0;
          box-shadow: 0 0 8px #d4a85788;
        }
        .feature-text {
          font-size: 15px;
          color: rgba(255,255,255,0.88);
          font-family: 'Cinzel', serif;
          letter-spacing: 0.3px;
        }
        .btn-row {
          display: flex;
          gap: 16px;
          margin-top: 8px;
          flex-wrap: wrap;
        }
        .btn-android, .btn-ios {
          display: flex;
          align-items: center;
          gap: 10px;
          border: none;
          border-radius: 10px;
          padding: 14px 28px;
          font-size: 15px;
          font-family: 'Cinzel', serif;
          font-weight: 700;
          cursor: pointer;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          letter-spacing: 0.3px;
        }
        .btn-android {
          background: #d4a857;
          color: #1c0a00;
          box-shadow: 0 4px 14px rgba(0,0,0,0.25);
        }
        .btn-ios {
          background: rgba(255,255,255,0.92);
          color: #1c0a00;
          box-shadow: 0 4px 14px rgba(0,0,0,0.15);
        }
        .btn-android.btn--hovered {
          transform: translateY(-3px);
          box-shadow: 0 12px 28px rgba(0,0,0,0.4);
        }
        .btn-ios.btn--hovered {
          transform: translateY(-3px);
          box-shadow: 0 12px 28px rgba(0,0,0,0.35);
        }

        /* ── RIGHT ── */
        .right {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .downloads-badge {
          position: absolute;
          top: -24px; right: 0px;
          background: #d4a857;
          color: #1c0a00;
          border-radius: 30px;
          padding: 8px 18px;
          display: flex;
          align-items: center;
          gap: 8px;
          z-index: 10;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }
        .downloads-text {
          font-family: 'Cinzel', serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }

        /* ── Phone ── */
        .phone {
          width: 280px;
          background: linear-gradient(175deg, #2c1010 0%, #1a0808 100%);
          border-radius: 36px;
          border: 2px solid rgba(255,255,255,0.1);
          overflow: hidden;
          box-shadow: 0 40px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08);
          animation: float 6s ease-in-out infinite;
          display: flex;
          flex-direction: column;
        }
        .notch {
          width: 90px; height: 24px;
          background: #0d0404;
          border-radius: 0 0 16px 16px;
          margin: 0 auto 4px;
        }
        .app-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px 14px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .app-icon-wrap {
          width: 44px; height: 44px;
          background: linear-gradient(135deg, #c0392b, #922b21);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(192,57,43,0.4);
        }
        .app-icon-emoji { font-size: 22px; }
        .app-name {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 13px;
          font-weight: 700;
          color: #d4a857;
          line-height: 1.3;
        }
        .app-tagline {
          font-size: 10px;
          color: rgba(255,255,255,0.5);
          font-family: sans-serif;
          letter-spacing: 0.3px;
        }
        .song-list {
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding: 8px 10px;
          flex: 1;
        }
        .song-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 9px 10px;
          border-radius: 10px;
          cursor: pointer;
          transition: background 0.2s ease, border-left 0.2s ease;
          background: rgba(255,255,255,0.04);
          border-left: 3px solid transparent;
        }
        .song-row--active {
          background: rgba(212,168,87,0.15);
          border-left: 3px solid #d4a857;
        }
        .song-thumb {
          width: 34px; height: 34px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
          font-size: 14px;
          transition: background 0.3s ease;
          background: linear-gradient(135deg, #922b21, #7b1a1a);
        }
        .song-thumb--active {
          background: linear-gradient(135deg, #d4a857, #c0392b);
        }
        .song-info { flex: 1; min-width: 0; }
        .song-title {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color 0.2s ease;
          line-height: 1.4;
          color: #f5e6c8;
        }
        .song-title--active { color: #d4a857; }
        .song-meta {
          font-size: 9px;
          color: rgba(255,255,255,0.35);
          font-family: sans-serif;
          margin-top: 1px;
        }
        .song-duration {
          font-size: 10px;
          color: rgba(255,255,255,0.3);
          font-family: monospace;
          flex-shrink: 0;
        }
        .mini-player {
          background: rgba(212,168,87,0.12);
          border-top: 1px solid rgba(212,168,87,0.2);
          padding: 10px 14px 8px;
        }
        .mini-player-left {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 8px;
        }
        .mini-thumb {
          width: 28px; height: 28px;
          background: #d4a857;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          color: #1c0a00;
          flex-shrink: 0;
          padding-left: 2px;
        }
        .mini-title {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 11px;
          color: #f5e6c8;
          font-weight: 600;
        }
        .mini-sub {
          font-size: 9px;
          color: #d4a857;
          font-family: sans-serif;
        }
        .progress-bar {
          height: 3px;
          background: rgba(255,255,255,0.1);
          border-radius: 2px;
          overflow: hidden;
        }
        .progress-fill {
          width: 62%;
          height: 100%;
          background: linear-gradient(90deg, #d4a857, #f39c12);
          border-radius: 2px;
          animation: progressAnim 2s ease-out forwards;
        }
        .home-bar {
          width: 80px; height: 4px;
          background: rgba(255,255,255,0.15);
          border-radius: 2px;
          margin: 10px auto 12px;
        }

        /* ════════════════════════════════════
           RESPONSIVE BREAKPOINTS
        ════════════════════════════════════ */

        /* ── Tablet: 768px – 1024px ── */
        @media (max-width: 1024px) {
          .app-section {
            padding: 60px 32px;
          }
          .inner {
            gap: 48px;
          }
          .subheading {
            font-size: 16px;
          }
          .feature-text {
            font-size: 13px;
          }
          .btn-android, .btn-ios {
            padding: 12px 20px;
            font-size: 13px;
          }
        }

        /* ── Stacked layout: below 860px ── */
        @media (max-width: 860px) {
          .app-section {
            padding: 60px 24px 80px;
            align-items: flex-start;
          }
          .inner {
            grid-template-columns: 1fr;
            gap: 60px;
          }
          .left {
            align-items: center;
            text-align: center;
          }
          .body-text {
            text-align: center;
            max-width: 540px;
          }
          .feature-list {
            align-items: flex-start;
            width: fit-content;
            margin: 0 auto;
          }
          .btn-row {
            justify-content: center;
          }
          .right {
            margin-top: 16px;
          }
          .downloads-badge {
            top: -20px;
            right: 50%;
            transform: translateX(120px);
          }
        }

        /* ── Mobile: up to 600px ── */
        @media (max-width: 600px) {
          .app-section {
            padding: 48px 16px 64px;
          }
          .eyebrow {
            letter-spacing: 3px;
            font-size: 10px;
          }
          .subheading {
            font-size: 14px;
          }
          .body-text {
            font-size: 14px;
            line-height: 1.75;
          }
          .feature-text {
            font-size: 12px;
          }
          .btn-row {
            flex-direction: column;
            align-items: stretch;
            width: 100%;
            max-width: 320px;
          }
          .btn-android, .btn-ios {
            justify-content: center;
            padding: 13px 20px;
            font-size: 14px;
          }
          .phone {
            width: 260px;
          }
          .downloads-badge {
            transform: translateX(100px);
          }
        }

        /* ── Small mobile: up to 400px ── */
        @media (max-width: 400px) {
          .inner {
            gap: 48px;
          }
          .phone {
            width: 240px;
          }
          .app-icon-wrap {
            width: 38px; height: 38px;
          }
          .song-row {
            padding: 7px 8px;
          }
          .song-thumb {
            width: 30px; height: 30px;
          }
          .downloads-badge {
            transform: translateX(80px);
          }
        }
      `}</style>
    </div>
  );
}